<template>
  <Modal
    v-model="_value"
    width="400"
    title="ZT设置ADAS报警使能"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="150">
      <FormItem prop="alarmType" label="报警类型">
        <Select v-model="setDriverCardParams.Type" style="width: 220px;">
          <Option v-for="item in TypeOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="alarmType" label="ADAS报警类型" v-if="setDriverCardParams.Type == 0">
      <Select v-model="setDriverCardParams.alarmType" style="width: 220px;">
        <Option v-for="item in ADASalarmTypeOptions" :value="item.value" :key="item.value">
          {{item.name}}
        </Option>
      </Select>
    </FormItem>
      <FormItem prop="alarmType" label="DSM报警类型" v-else>
        <Select v-model="setDriverCardParams.alarmType" style="width: 220px;">
          <Option v-for="item in DSMalarmTypeOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="LevelThldSpd" label="报警起始速度">
        <Input v-model="setDriverCardParams.LevelThldSpd" placeholder="报警起始速度" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="EnableL1" label="一级报警使能">
        <Select v-model="setDriverCardParams.EnableL1" style="width: 220px;">
          <Option v-for="item in EnableOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="EnableL1" label="二级报警使能">
        <Select v-model="setDriverCardParams.EnableL2" style="width: 220px;">
          <Option v-for="item in EnableOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="EnableL1" label="一级附件开关">
        <Select v-model="setDriverCardParams.AttEnableL1" style="width: 220px;">
          <Option v-for="item in EnableOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="EnableL1" label="二级附件开关">
        <Select v-model="setDriverCardParams.AttEnableL2" style="width: 220px;">
          <Option v-for="item in EnableOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="onSendDriverCardParams">确认</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'ztdriveralarmenablelmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        Type: 0,
        alarmType: null,
        LevelThldSpd: 60,
        EnableL1: 1,
        EnableL2: 1,
        AttEnableL1: 1,
        AttEnableL2: 1,
      },

      TypeOptions: [
        {name: 'ADAS', value: 0},
        {name: 'DSM', value: 1},
      ],

      ADASalarmTypeOptions: [
        {name: '前向碰撞', value: 0},
        {name: '车距过近', value: 1},
        {name: '车道偏离', value: 2},
        {name: '行人碰撞', value: 3},
      ],

      DSMalarmTypeOptions: [
        {name: '生理疲劳驾驶（打哈欠或者闭眼）', value: 0},
        {name: '分神驾驶', value: 1},
        {name: '抽烟', value: 2},
        {name: '打电话', value: 3},
        {name: '遮挡摄像头', value: 4},
        {name: '未检测到驾驶员', value: 5},
      ],

      EnableOptions:[
        {name: '关闭使能', value: 0},
        {name: '开启使能', value: 1},
      ],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.Type = 0
        this.setDriverCardParams.alarmType = null
        this.setDriverCardParams.LevelThldSpd = 50
        this.setDriverCardParams.EnableL1 = 1
        this.setDriverCardParams.EnableL2 = 1
        this.setDriverCardParams.AttEnableL1 = 1
        this.setDriverCardParams.AttEnableL2 = 1

      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.Type = 0
      this.setDriverCardParams.alarmType = null
      this.setDriverCardParams.LevelThldSpd = 50
      this.setDriverCardParams.EnableL1 = 1
      this.setDriverCardParams.EnableL2 = 1
      this.setDriverCardParams.AttEnableL1 = 1
      this.setDriverCardParams.AttEnableL2 = 1
  },
    onSendDriverCardParams () {
      let content
      if (this.setDriverCardParams.Type == 0) {
        content = "_CoMmAnD@XmL:<Param_AdasAlarmSet><MESSAGE_ID>1</MESSAGE_ID><MESSAGE_TYPE>2</MESSAGE_TYPE><id>" + this.setDriverCardParams.alarmType + "</id><LevelThldSpd>" + this.setDriverCardParams.LevelThldSpd + "</LevelThldSpd><EnableL1>" + this.setDriverCardParams.EnableL1 + "</EnableL1><EnableL2>" + this.setDriverCardParams.EnableL2 + "</EnableL2><AttEnableL1>" + this.setDriverCardParams.AttEnableL1 + "</AttEnableL1><AttEnableL2>" + this.setDriverCardParams.AttEnableL2 + "</AttEnableL2></Param_AdasAlarmSet>"
      }else {
        content = "_CoMmAnD@XmL:<Param_DsmAlarmSet><MESSAGE_ID>1</MESSAGE_ID><MESSAGE_TYPE>2</MESSAGE_TYPE><id>" + this.setDriverCardParams.alarmType + "</id><LevelThldSpd>" + this.setDriverCardParams.LevelThldSpd + "</LevelThldSpd><EnableL1>" + this.setDriverCardParams.EnableL1 + "</EnableL1><EnableL2>" + this.setDriverCardParams.EnableL2 + "</EnableL2><AttEnableL1>" + this.setDriverCardParams.AttEnableL1 + "</AttEnableL1><AttEnableL2>" + this.setDriverCardParams.AttEnableL2 + "</AttEnableL2></Param_DsmAlarmSet>"
      }

      console.log(content)

      let batchSendCmd = {cmd:null,urgent:false}
      batchSendCmd.cmd = content
      batchSendCmd.urgent = true
      // console.log(batchSendCmd)
      this.$emit('ZT_DriverAlarmEnablel',batchSendCmd)
      // store.dispatch('NetCommandServ_SendCommand', {
      //   params: { id: this._initValue, content: content, urgent: true }
      // }).then(() => {
      //   this.$Message.success('发送成功')
      // }).catch(err => {
      //   this.$Message.error(err)
      // })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
